import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { window, exists } from 'browser-monads';
import Breadcrumbs from 'components/Breadcrumbs';
import HeaderWrapper from 'components/Header/HeaderWrapper';
import WebsiteFooter from 'components/Footer';
import useOptinMonsterDriftInteraction from 'hooks/useOptinMonsterDriftInteraction';
import { isProd } from 'utils/urlHelper';
import scroll from 'utils/smoothScroll';
import checkHeroDark from 'utils/checkHeroDark';

const WebsiteLayout = ({
  backgroundColor,
  breadcrumbs,
  children,
  footer,
  header,
  hero,
  useProgressbar,
  stickyHeader,
  subNav,
  theme,
  layout,
}) => {
  const isSimpleHeaderTheme = theme === 'simpleHeader';
  const [headerType, toggleHeaderType] = useState({
    simpleHeader: theme === 'simpleHeader',
    mainHeader: null,
  });
  const [isStickyWithHeader, toggleIsStickyWithHeader] = useState(null);
  const [isStickyWithoutHeader, toggleIsStickyWithoutHeader] = useState(null);
  const isHeroDark = checkHeroDark(hero);
  const [isProdSite, setIsProdSite] = useState(true);

  useEffect(() => {
    setIsProdSite(isProd);
  });

  useOptinMonsterDriftInteraction();

  useEffect(() => {
    scroll();
  }, []);

  useEffect(() => {
    window.logoNavigation = path => {
      const logoContainer = document.querySelector('.header-logo-container');
      const svgs = document.querySelectorAll('.header-logo-container svg');
      const oldLink = document.querySelector('.header-logo-container a');

      if (oldLink) {
        oldLink.remove();
      }

      const logoLink = document.createElement('a');
      logoLink.onclick = () => {
        window.location.href = path;
      };
      logoContainer.appendChild(logoLink);

      svgs.forEach(n => {
        logoLink.appendChild(n);
      });
    };
  }, []);

  return (
    <div
      style={{ position: 'relative', backgroundColor }}
      className={isProdSite ? '' : 'fs-exclude'}
    >
      {header && (
        <HeaderWrapper
          header={header}
          theme={theme || (isHeroDark ? 'darkHeroHeader' : 'lightHeroHeader')}
          simpleHeader={isSimpleHeaderTheme}
          stickyHeader={stickyHeader || !!hero}
          SubNav={subNav}
          toggleHeaderType={toggleHeaderType}
          toggleIsStickyWithHeader={toggleIsStickyWithHeader}
          toggleIsStickyWithoutHeader={toggleIsStickyWithoutHeader}
          useProgressbar={useProgressbar}
        />
      )}
      {breadcrumbs?.data && (
        <Breadcrumbs
          breadcrumbs={breadcrumbs.data}
          transparent={breadcrumbs.transparent}
          absoluteMode={breadcrumbs.absolute}
          theme={breadcrumbs.theme || (isHeroDark ? 'light' : 'dark')}
          simpleHeader={headerType.simpleHeader}
          stickyWithoutHeader={isStickyWithoutHeader}
          layout={layout}
          subNav={subNav}
        />
      )}
      <MainContainer
        stickyWithHeader={isStickyWithHeader}
        stickyWithoutHeader={isStickyWithoutHeader}
      >
        {children}
      </MainContainer>
      {footer?.navigation?.navigation && (
        <WebsiteFooter navigation={footer?.navigation?.navigation} />
      )}
    </div>
  );
};

if (exists(window)) {
  window.dataLayer = window.dataLayer || [];
  window.Bizible = window.Bizible || { Push: () => {} };
}

WebsiteLayout.propTypes = {
  children: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string,
};

WebsiteLayout.defaultProps = {
  backgroundColor: 'White',
};

export default WebsiteLayout;

const MainContainer = styled.main`
  position: relative;
  padding-top: ${({ stickyWithHeader, stickyWithoutHeader }) =>
    (stickyWithHeader || stickyWithoutHeader) && '119px'};
`;
